export enum ColorMap {
  DEFAULT = 'default',
  GOLD = 'gold',
  WARNING = 'warning',
  SUCCESS = 'success',
  ERROR = 'error',
}
